import { createApi } from '@reduxjs/toolkit/query/react';
import { urls } from '../../utils/helpers/ApiClient';
import axiosFetchBase from '../axiosFetchBase';

export const roomsResponsiblePersonsApi = createApi({
  reducerPath: 'roomsResponsiblePersonsApi',
  keepUnusedDataFor: 0,
  baseQuery: axiosFetchBase,
  endpoints: (builder) => ({
    getRoomsResponsiblePersons: builder.query({
      query() {
        return {
          url: urls.roomResponsibles,
          method: 'GET',
        };
      },
    }),
    getRoomsResponsiblePersonsDetail: builder.query({
      query(id) {
        return {
          url: urls.roomResponsibleDetail(id),
          method: 'GET',
        };
      },
    }),
    saveRoomsResponsiblePersons: builder.mutation({
      query(req) {
        if (req.id) {
          return {
            url: urls.roomResponsibleDetail(req.id),
            method: 'PUT',
            data: req.data,
          };
        } else {
          return {
            url: urls.roomResponsibles,
            method: 'POST',
            data: req.data,
          };
        }
      },
    }),
    deleteRoomsResponsiblePersons: builder.mutation({
      query(id) {
        return {
          url: urls.roomResponsibleDetail(id),
          method: 'DELETE',
        };
      },
    }),
  }),
});

export const {
  useGetRoomsResponsiblePersonsQuery: useGetRoomResponsiblePersonsQuery,
  useGetRoomsResponsiblePersonsDetailQuery:
    useGetRoomResponsiblePersonsDetailQuery,
  useSaveRoomsResponsiblePersonsMutation: useSaveRoomResponsiblePersonsMutation,
  useDeleteRoomsResponsiblePersonsMutation:
    useDeleteRoomResponsiblePersonsMutation,
} = roomsResponsiblePersonsApi;
